<template>
  <div>
    <TransitionRoot :show="localOpen" as="template">
      <Dialog class="relative z-50" @close="localOpen = false">
        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 left-0 flex w-full">
              <TransitionChild
                :enter="'transform transition ease-in-out duration-150'"
                :enter-from="
                  isTopLevel ? '-translate-x-full' : 'translate-x-full'
                "
                :enter-to="isTopLevel ? 'translate-x-0' : 'translate-x-0'"
                :leave="
                  isTopLevel
                    ? 'transform transition ease-in-out duration-150'
                    : 'transform transition ease-in-out duration-200'
                "
                :leave-from="isTopLevel ? 'translate-x-0' : 'translate-x-0'"
                :leave-to="
                  isTopLevel ? '-translate-x-full' : 'translate-x-full'
                "
                as="template"
              >
                <DialogPanel class="pointer-events-auto w-screen">
                  <div class="flex h-full flex-col bg-white shadow-xl">
                    <!-- Header -->
                    <MegaMenuMobileHeader
                      v-model:open="localOpen"
                      :title="title"
                      :is-top-level="isTopLevel"
                    />

                    <!-- Body -->
                    <MegaMenuMobileBody
                      v-if="megaMenuStore.isMegaMenuOpen"
                      :menu-items="menuItems"
                    />

                    <!-- Footer -->
                    <MegaMenuMobileFooter :show-customer="showCustomer">
                      <slot name="footer" />
                    </MegaMenuMobileFooter>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import MegaMenuMobileHeader from '@/partials/MegaMenuPartial/Partial/MegaMenuMobileHeader.vue';
import MegaMenuMobileFooter from '@/partials/MegaMenuPartial/Partial/MegaMenuMobileFooter.vue';
import MegaMenuMobileBody from '@/partials/MegaMenuPartial/Partial/MegaMenuMobileBody.vue';
import { MegaMenuItem } from '@/types/MegaMenu/MegaMenuItem';
import { useMegaMenuStore } from '@/stores/MegaMenu/MegaMenuStore.ts';

const emits = defineEmits(['update:open']);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
    default: false,
  },

  menuItems: {
    type: Array as PropType<MegaMenuItem[]>,
    required: true,
  },

  title: {
    type: String,
    required: false,
    default: undefined,
  },

  isTopLevel: {
    type: Boolean,
    required: false,
    default: false,
  },

  showCustomer: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const localOpen = computed({
  get: () => props.open,
  set: value => {
    emits('update:open', value);
  },
});

const megaMenuStore = useMegaMenuStore();
</script>
